import { ceil } from 'lodash'
import Link from 'next/link'
import React from 'react'
import { Star } from 'react-feather'
import { useLocale } from 'src/lib/hooks/useLocal'
import { AppStoreAppType } from 'src/lib/types/AppStoreTypes'
import { currencyFormatter } from 'src/lib/utils/formatters'
interface AppDetailsInfoProps {
  appDetails: AppStoreAppType
}

const AppDetailsInfo: React.FC<AppDetailsInfoProps> = ({ appDetails }) => {
  const { t } = useLocale()
  const markedUpPrice = appDetails?.merchantAppDetails?.marked_up_price

  const PriceComponent = () => {
    const priceFromTiersMapping = Object.values(appDetails.pricingTiers[0]?.feature_price_mapping || {})?.find(
      val => val > 0
    )
    //This price is needed to check if free or not
    const price = priceFromTiersMapping

    if (markedUpPrice) {
      const percentageOff = price && markedUpPrice ? (((markedUpPrice - price) / markedUpPrice) * 100).toFixed(2) : 0

      return (
        <span className='flex text-sm items-center font-medium gap-2 pl-4'>
          {price ? (
            <span className='text-sm font-medium'>{t('amount_per_month', { amount: currencyFormatter(price) })}</span>
          ) : (
            <>
              <span className='font-semibold text-lg text-primary-dark'>{t('free')}</span>

              <span className=' line-through'>
                {t('amount_per_month', { amount: currencyFormatter(markedUpPrice) })}
              </span>
            </>
          )}
          {price && (
            <span className='flex text-sm font-medium gap-2'>
              <span className=' line-through'>{currencyFormatter(markedUpPrice)}</span>
              <span>{`(${percentageOff}% off)`}</span>
            </span>
          )}
        </span>
      )
    }
    return price ? (
      <p className='text-sm font-medium'>{currencyFormatter(price)} per month</p>
    ) : (
      <span className='font-semibold text-lg text-primary-dark'>{t('free')}</span>
    )
  }

  const numberOfRatings = ceil(appDetails.numberOfBrandUsing / 4)

  return (
    <>
      <div className='flex justify-start gap-24 border-y-1 py-6 px-3'>
        <div className='flex flex-col gap-[2px]'>
          <span className='flex items-center gap-1 font-medium'>
            <Star fill='#1E1E1E' height={11} width={11} />
            {appDetails?.rating ?? 5.0}
          </span>
          <span className='text-xs font-normal'>{numberOfRatings}+ ratings</span>
        </div>
        <div className='flex flex-col gap-[2px] font-medium'>
          <span>{appDetails?.numberOfBrandUsing ?? 89}+</span>
          <span className='text-xs font-normal'>brands using this</span>
        </div>
        <div dangerouslySetInnerHTML={{ __html: appDetails?.brandDetails }}></div>
      </div>
      <div className='border-b-1 pb-11 pt-4 px-3'>
        <div className='w-[90%] grid grid-cols-2 gap-14 '>
          <h2 className=' text-lg font-semibold'>Features</h2>
          <div className='flex flex-col gap-4 pl-2'>
            <div dangerouslySetInnerHTML={{ __html: appDetails?.features ?? t('information_not_available') }}></div>
          </div>
        </div>
      </div>
      <div className='border-b-1 pt-4 pb-11 px-3'>
        <div className='w-[90%] grid grid-cols-2 gap-14 '>
          <h2 className='text-lg font-semibold w-1/2'>Pricing</h2>
          <PriceComponent />
        </div>
      </div>
    </>
  )
}

export default AppDetailsInfo
